// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3tM94","title":"Info_title__397k1","selects":"Info_selects__1PcGu","requiredAsterisk":"Info_requiredAsterisk__2OUmn"};